// @flow

import $ from 'jquery'

import { Analytics } from './analytics/analytic-v2'

const getUrl = (urlType: string): string => {
  if (urlType === 'full') {
    return window.location.href
  }
  if (urlType === 'pathname') {
    return window.location.origin + window.location.pathname
  }

  return window.location.origin
}

// В десктопной версии ВК еще есть параметр &comment=, но к сожалению он на мобиле не работает.
// TODO решить, как лучше сделать, чтобы именно в ВК, в мобиле был весь текст в title=, а на десктопе разделялся в title= и &comment=
// Как вариант делать if ($(window).width() <= 768) {} и разный текст. Но подумать над более лаконичным вариантом

/**
 * Общая функция шера, в которой всё на своих местах, с нужным форматированием и encodeURI.
 * @param {string} text - текст шера
 * @param {string} imUrl - адрес картинки
 * @param {string} urlType - 'origin' - только домен, 'pathname' - домен + текущая страница, 'full' - полный урл c ЮТМ метками
 */
const shareCommon = {
  shareVk: (text: string, imUrl: string, urlType: 'origin' | 'pathname' | 'full' = 'origin') => {
    window.open(
      `https://vk.com/share.php?title=${encodeURIComponent(text)}&image=${imUrl}&url=${getUrl(urlType)}`,
      '_blank'
    )
  },

  shareTg: (text: string, urlType: 'origin' | 'pathname' | 'full' = 'origin') => {
    window.open(`https://t.me/share/url?url=${getUrl(urlType)}&text=${encodeURIComponent(text)}`, '_blank')
  },

  shareWa: (text: string, urlType: 'origin' | 'pathname' | 'full' = 'origin') => {
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(text)}%20-%20${getUrl(urlType)}`, '_blank')
  },
}

/**
 * Общая функция для добавления слушателей на все три стандартные кнопки шера.
 * Можно вызывать ее, а можно по отдельности каждую, описанную выше.
 * По отдельности требуется, когда необходима еще какая-то дополнительная логика
 * @param {string} text - текст шера
 * @param {string} imUrl - адрес картинки
 * @param {string} urlType - 'origin' - только домен, 'pathname' - домен + текущая страница, 'full' - полный урл c ЮТМ метками
 * @param {function} callback - коллбэк, который вызывается после клика по кнопке шера
 */
export const shareListeners = (
  text: string,
  imUrl: string,
  urlType: 'origin' | 'pathname' | 'full' = 'origin',
  callback: function = () => {}
) => {
  $('[data-share="vk"]').on('click', () => {
    shareCommon.shareVk(text, imUrl, urlType)
    Analytics.shareSocial('click', 'vk')

    callback()
  })

  $('[data-share="tg"]').on('click', () => {
    shareCommon.shareTg(text, urlType)
    Analytics.shareSocial('click', 'tg')

    callback()
  })

  $('[data-share="wa"]').on('click', () => {
    shareCommon.shareWa(text, urlType)
    Analytics.shareSocial('click', 'wa')

    callback()
  })
}
